import { render, staticRenderFns } from "./applyExtraPoints.vue?vue&type=template&id=61f28b64&scoped=true&"
import script from "./applyExtraPoints.vue?vue&type=script&lang=js&"
export * from "./applyExtraPoints.vue?vue&type=script&lang=js&"
import style0 from "./applyExtraPoints.vue?vue&type=style&index=0&id=61f28b64&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f28b64",
  null
  
)

export default component.exports